import { createRouteRef } from '@backstage/core-plugin-api';

export const customerExperienceRouteRef = createRouteRef({
  id: 'customer-experience',
});
